export class Task {
    type: string;
    borrowerId: number;
    assignedName: string;
    contactName: string;
    userRole?: 'fundingManager' | 'fundingDesk';
    fromRole?: string;
    taskType?: string;
    action?: string; // to-do: we should refactor to remove this
}
